import React, { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import rgBanner from '../../assets/images/rgBanner.jpg'
import { AuthConext } from '../../context/AuthProvider';
import useTitle from '../../hooks/useTitle';

const Register = () => {
    const [error, setError] = useState(null)
    const { createUser, updateUser } = useContext(AuthConext)
    useTitle('register')


    let navigate = useNavigate();
    let location = useLocation();
    let from = location.state?.from?.pathname || "/";


    const submitHandler = (event) => {
        event.preventDefault()
        const form = event.target;
        const name = form.name.value;
        const email = form.email.value;
        const url = form.url.value;
        const password = form.password.value;
        // console.log(email, name, url)
        createUser(email, password)
            .then(result => {
                toast.success('successfully registered', {duration: 3000})
                form.reset()
                const user = result.user;
                updateUsers(name, url)
                console.log(user)


                  // JWT TOKEN SERVER SITE CONNECT AND TOKEN LOCAL STORATE SAVED
                  const currentUser = {
                    email: user.email
                }

                fetch(`https://b6a11-service-review-server-side-mdismail645221.vercel.app/jwt`, {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(currentUser)
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data)
                        if (data) {
                            localStorage.setItem('YUMMY-TOKEN', data.token)
                        }
                        navigate(from, { replace: true });
                    })


            })
            .catch((error) => {
                console.log(error)
                setError(error.message)
            })
    }


    const updateUsers = (name, url) => {
        const profile = {
            displayName: name,
            photoURL: url
        }
        updateUser(profile)
            .then((result => {
                // const user= result.user;
                // console.log(user)
            }))
            .catch((error) => {
                console.log(error);
                toast.error(error)
                setError(error.message)
            })

    }




    return (
        <div className="relative">
            <img
                src={rgBanner}
                className="absolute inset-0 object-cover w-full h-full"
                alt=""
            />
            <div className="relative bg-gray-900 bg-opacity-75">
                <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                    <div className="flex flex-col items-center justify-between xl:flex-row">
                        <div className="w-full max-w-xl mb-12 xl:mb-0 xl:pr-16 xl:w-7/12">
                            <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-white sm:text-4xl sm:leading-none">
                                Wellcome ! Create Your <br className="hidden md:block" />
                                Registered{' '}
                                <span className="text-teal-accent-400">Form</span>
                            </h2>
                            <p className="max-w-xl mb-4 text-base text-gray-400 md:text-lg">
                                Create amazing and attractive login or Register forms in Elemtor without and any coding using Ea losing Register form.
                            </p>
                            <p
                                className="inline-flex items-center font-semibold tracking-wider transition-colors duration-200 text-white text-lg"
                            >
                                Already hava a account? <Link to='/login' className='primary-color font-bold px-3 hover:underline'>Log in</Link>
                                <svg
                                    className="inline-block w-3 ml-2"
                                    fill="currentColor"
                                    viewBox="0 0 12 12"
                                >
                                    <path d="M9.707,5.293l-5-5A1,1,0,0,0,3.293,1.707L7.586,6,3.293,10.293a1,1,0,1,0,1.414,1.414l5-5A1,1,0,0,0,9.707,5.293Z" />
                                </svg>
                            </p>
                        </div>
                        <div className="w-full max-w-xl xl:px-8 xl:w-5/12">
                            <div className="bg-white rounded shadow-2xl p-7 sm:p-10">
                                <h3 className="mb-4 text-xl font-semibold sm:text-center sm:mb-6 sm:text-2xl">
                                    Register for updates
                                </h3>
                                <form onSubmit={submitHandler}>
                                    <div className="mb-1 sm:mb-2">
                                        <label
                                            htmlFor="firstName"
                                            className="inline-block mb-1 font-medium"
                                        >
                                            Name
                                        </label>
                                        <input
                                            placeholder="John"
                                            required
                                            type="text"
                                            className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                                            id="firstName"
                                            name="name"
                                        />
                                    </div>
                                    <div className="mb-1 sm:mb-2">
                                        <label
                                            htmlFor="url"
                                            className="inline-block mb-1 font-medium"
                                        >
                                            Photo URL
                                        </label>
                                        <input
                                            placeholder="URL"
                                            required
                                            type="text"
                                            className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                                            id="lastName"
                                            name="url"
                                        />
                                    </div>
                                    <div className="mb-1 sm:mb-2">
                                        <label
                                            htmlFor="email"
                                            className="inline-block mb-1 font-medium"
                                        >
                                            E-mail
                                        </label>
                                        <input
                                            placeholder="john.doe@example.org"
                                            required
                                            type="text"
                                            className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                                            id="email"
                                            name="email"
                                        />
                                    </div>
                                    {/* password --> */}
                                    <div className="mb-1 sm:mb-2">
                                        <label
                                            htmlFor="email"
                                            className="inline-block mb-1 font-medium"
                                        >
                                            Password
                                        </label>
                                        <input
                                            placeholder="password"
                                            required
                                            type="password"
                                            className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                                            id="password"
                                            name="password"
                                        />
                                    </div>
                                    <div className="mt-4 mb-2 sm:mb-4">
                                        <button
                                            type="submit"
                                            className="inline-flex items-center justify-center w-full h-12 px-6  tracking-wide primary-bg-color hover:bg-[#db3a0d] text-black font-bold transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                                        >
                                            Subscribe
                                        </button>
                                    </div>
                                    <p className="text-xs text-red-600 font-semibold sm:text-sm">
                                        {error}
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;